import React from "react";
import "./ThankYou.css";
import { images } from "../../../assets";

function ThankYou() {
  return (
    <div className="thankYou">
      <div className="thankLeftpart">
        <div className="thankTitle">
        Thank You!
        </div>
        <div className="thankMessage">
          <div>Your message has been successfully delivered.</div>
          <div>We will reach back to you within 1-3 business days.</div>
        </div>
      </div>
      <div className="thankRightpart">
        <img src={images.thumbsUp} alt="thumbsup" />
      </div>
    </div>
  );
}

export default ThankYou;
